import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { FormLoader } from '@shapeable/ui';

const cls = classNames('contact-us-iframe-embed');

// -------- Types -------->

// -------- Props -------->

export type ContactUsIframeEmbedProps = Classable & HasChildren & {
}

export const ContactUsIframeEmbedDefaultProps: ContactUsIframeEmbedProps = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
});

const IframeStyles = breakpoints({
  base: css`
    width: 100%;
    height: 800px;
    border: none;
  `,
});

const LoadingStyles = breakpoints({
  base: css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  Iframe: styled.iframe`${IframeStyles}`,
  Loading: styled(FormLoader)`${LoadingStyles}`,
};

export const ContactUsIframeEmbed: Shapeable.FC<ContactUsIframeEmbedProps> = (props) => {
  const { className, children } = props;
  
  const [isLoading, setIsLoading] = React.useState(true);
    
    const handleLoad = () => {
      setIsLoading(false);
    };
    
    return (
      <My.Container className={cls.name(className)}>
        {isLoading && (
          <My.Loading>Loading...</My.Loading>
        )}
        <My.Iframe 
          src='https://villarsinstitute.odoo.com/contactus'
          title="Global Learning Council Contact Us"
          onLoad={handleLoad}
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      </My.Container>
    )
};

ContactUsIframeEmbed.defaultProps = ContactUsIframeEmbedDefaultProps;
ContactUsIframeEmbed.cls = cls;